export default __webpack_public_path__ + "static/media/Q16_4_resized.61e0ff8e.jpg";